import {
  DevicesService,
  GetDeviceDateTime_GetDeviceDateTimeRequestResponse,
  ReadUpsParams_ReadUpsParamsResponse,
  StandardTimeModel,
  UpsService,
} from "../api";

export const UpsApi = {
  // Получение параметров ИБП
  getUpsParams: (id: string): Promise<ReadUpsParams_ReadUpsParamsResponse> => {
    return UpsService.getApiUpsParams(id);
  },

  // Получение времени устройства
  getTime: (id: string): Promise<GetDeviceDateTime_GetDeviceDateTimeRequestResponse> => {
    return DevicesService.getApiDevicesTime(id);
  },

  // Сохранение времени устройства
  saveTime: async (id: string, time: string): Promise<boolean> => {
    const payload: StandardTimeModel = {time};
    await DevicesService.postApiDevicesTime(id, payload);
    return true;
  },

  // Отключение выхода ИБП
  outputDisable: async (id: string): Promise<boolean> => {
    await UpsService.postApiUpsOutputDisable(id);
    return true;
  },

  // Изменение состояния выхода ИБП
  setOutputState: async (id: string, enabled: boolean): Promise<boolean> => {
    await UpsService.postApiUpsOutputState(id, {enabled});
    return true;
  }
}
